// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomLinkedin2 = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '14',
      height: '14',
      viewBox: '0 0 14 14',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0.84375 2.46366C0.84375 2.04495 1.23505 1.70508 1.71741 1.70508H11.7913C12.2739 1.70508 12.665 2.04495 12.665 2.46366V11.5365C12.665 11.9553 12.2739 12.2949 11.7913 12.2949H1.71741C1.2351 12.2949 0.84375 11.9554 0.84375 11.5366V2.46354V2.46366Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.43571 10.532V5.78344H2.66677V10.532H4.43589H4.43571ZM3.55161 5.13522C4.16834 5.13522 4.5523 4.77059 4.5523 4.31491C4.54076 3.84884 4.16834 3.49438 3.56333 3.49438C2.95791 3.49438 2.5625 3.84884 2.5625 4.31487C2.5625 4.77055 2.94632 5.13518 3.54002 5.13518H3.55147L3.55161 5.13522ZM5.41484 10.532H7.18364V7.88046C7.18364 7.73873 7.19518 7.59663 7.24191 7.49539C7.36973 7.21172 7.66078 6.91808 8.14956 6.91808C8.78948 6.91808 9.04562 7.3535 9.04562 7.99191V10.532H10.8144V7.80931C10.8144 6.35082 9.94182 5.67212 8.77803 5.67212C7.82388 5.67212 7.40483 6.14795 7.172 6.47204H7.18378V5.78361H5.41493C5.43802 6.22907 5.41479 10.5321 5.41479 10.5321L5.41484 10.532Z',
      fill: 'white',
    }),
  );

export { IconCustomLinkedin2 };
